<template>
  <section class="team">
    <img class="team__img" src="../assets/team/team.png">
    <div class="team__content container">
      <h1 class="team__title --fade-in-up" data-vertical-ivp-class="--animate">OUR TEAM</h1>
      <p class="team__description --fade-in-up" data-vertical-ivp-class="--animate">
				World renowned leaders in the field of decarbonization and sustainable homes 
				with decades of combined experience. 
			</p>
      <h1 class="team__subtitle --fade-in-up" data-vertical-ivp-class="--animate">LEADERSHIP SPOTLIGHT: NORBERT KLEBL</h1>
      <p class="team__description --fade-in-up" data-vertical-ivp-class="--animate">GeoSolar Technologies is proud to have Mr. Klebl as part of our team.
        Norbert is a former McKinsey partner of 16 years with an MBA from Columbia.
        His work is a key part of GST's approach.</p>
        
      <div class="team__owl-carousel owl-carousel owl-theme" id="owl-carousel-2">
        <div class="team__card">
          <p class="team__card-description">
            A seasoned 30-year public company executive and former Chairman and CEO of the Piper Aircraft Company.
          </p>
          <div class="team__card-lead">
            <h3 class="name">Stone Douglass</h3>
            <p class="position">Chairman and CEO</p>
          </div>
        </div>
        <div class="team__card">
          <p class="team__card-description">
            A highly respected solar engineer with Chevron Energy’s green operations and project manager and executive
            for a $400M solar/geothermal innovation project.
          </p>
          <div class="team__card-lead">
            <h3 class="name">Brent Mosbarger</h3>
            <p class="position">Co-Founder, Commercial Operations</p>
          </div>
        </div>
        <div class="team__card">
          <p class="team__card-description">
            Mr. Romenesko had a long career as an engineer and large-scale project manager for Johnson Controls and Siemens.
          </p>
          <div class="team__card-lead">
            <h3 class="name">Peter Romenesko</h3>
            <p class="position">Senior Strategic Advisor</p>
          </div>
        </div>
        <div class="team__card">
          <p class="team__card-description">
            Recognized as one of the leading zero-carbon innovation experts in the world. Norbert is a former McKinsey
            partner of 16 years with an MBA from Columbia.
          </p>
          <div class="team__card-lead">
            <h3 class="name">Norbert Klebl</h3>
            <p class="position">Co-Founder, Development Director</p>
          </div>
        </div>
        <div class="team__card">
          <p class="team__card-description">
            He received his PhD in engineering from the University of Illinois and had a 16-year career with ExxonMobil Energy Research.
          </p>
          <div class="team__card-lead">
            <h3 class="name">Dar-Lon Chang</h3>
            <p class="position">Director of New Product Development</p>
          </div>
        </div>
      </div>
      <div class="team__partners">
        <h1 class="team__title --fade-in-up" data-vertical-ivp-class="--animate">OUR STRATEGIC PARTNERS</h1>
        <div class="team__card-container">
          <div class="team__card --fade-in-right" data-vertical-ivp-class="--animate">
            <p class="team__card-description">
							Manhattan Street Capital is advising GeoSolar Technologies, Inc. on their 
							Reg A+ capital raise. Manhattan Street Capital is the premier online fundraising 
							platform that helps companies to make their IPO, and raise capital, 
							using Direct Listings, Regulation A+ and Regulation D, Regulation S and also to 
							make STO or Blockchain offerings that use Reg A+ or Reg D to be legitimate 
							securities offerings.
            </p>
            <div class="team__card-lead">
              <h3 class="name">Manhattan Street Capital</h3>
            </div>
          </div>
          <div class="team__card --fade-in-left" data-vertical-ivp-class="--animate">
            <p class="team__card-description">
              TAG Collective is overseeing marketing and communications for GeoSolar Technologies, Inc. Founded by Marilyn Lopez
              and Daniel Chartock, the firm focuses on helping clients break through the noise with StoryScaling™.
              We focus on the why behind why our customers should choose them, why we say what we say, and why our
              clients' messages will transcend platforms and audiences.
            </p>
            <div class="team__card-lead">
              <h3 class="name">TAG Collective</h3>
            </div>
          </div>
        </div>
      </div>
      <CTA />
    </div>
  </section>
</template>

<script>
const $ = require( 'jquery' );
import CTA from '../components/cta.vue';

export default {
  name: 'team',
  components: {
    CTA
  },
  data () {
    return {
    }
  },
  mounted() {
    $(document).ready(function(){
      $('#owl-carousel-2').owlCarousel({
        items: 2,
        loop: true,
        dotsEach: true,
        dots: true,
        margin: 25,
        autoplay: true,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        responsiveClass:true,
        responsive:{
          0:{
            items:1,
          },
          600:{
            items:1,
          },
          900:{
            items:2,
          }
        }
      });
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/components/ourteam.scss";
</style>
